<template>
  <div class="table-container">
    <public-table
      addPerm="User.Market.Application.SetStatus"
      :onAdd="
        () => {
          editPackage = defaultPackageVlue;
          showEditPackage = true;
        }
      "
      :column="column"
      :tableData="packages"
    >
      <template v-slot:name="{ row }">
        {{ row.name }}
        <el-tag
          style="margin-left: 5px"
          v-if="row.isTrial"
          type="success"
          size="mini"
          >试用</el-tag
        >
      </template>
      <template v-slot:packageType="{ row }">
        {{
          row.packageType === 'free'
            ? '免费'
            : row.packageType === 'pay'
            ? '付费'
            : '商业咨询'
        }}
      </template>
      <template v-slot:version="{ row }">
        {{ row.packageType !== 'business' ? row.version : '-' }}
      </template>

      <template v-slot:billtype="{ row }">{{
        row.packageType !== 'pay' ? '-' : '服务时长'
      }}</template>
      <template v-slot:billCycle="{ row }">{{
        row.packageType === 'pay' ? showBillCycle(row.billCycle) : '-'
      }}</template>
      <template v-slot:price="{ row }">
        {{ row.packageType === 'pay' ? row.price + '元' : '-' }}
      </template>
      <template v-slot:enable="{ row }">
        <span v-if="row.enable" style="color: #13ce66">可用</span>
        <span v-if="!row.enable" style="color: #ff4949">禁用</span>
      </template>
      <template v-slot:createTime="{ row }">{{
        row.createTime ? timetrans(row.createTime) : '-'
      }}</template>
      <template v-slot:operation="{ row }">
        <el-button
          size="mini"
          type="text"
          v-permit="'User.Market.Application.Package.Update'"
          @click="handleEditPackage(row)"
          >编辑</el-button
        >
        <el-button
          size="mini"
          type="text"
          v-permit="'User.Market.Application.Package.Delete'"
          @click="deletePackage(row)"
          style="margin-left: 0px"
          >删除</el-button
        >
      </template>
    </public-table>
    <EditAppPackage
      v-if="showEditPackage"
      :marketID="marketID"
      :appPackage="editPackage"
      :versions="versions"
      :appID="appID"
      :dialogVisible="showEditPackage"
      :onSuccess="editPackageSuccess"
      :onClose="() => ((showEditPackage = false), (editPackage = null))"
    ></EditAppPackage>
  </div>
</template>
<script>
import {
  deleteAppPackage,
  fetchAppPackages,
  fetchAppVersions
} from '@/api/app';
import { timetrans } from '@/utils/validate';
import { errorHandle } from '../../../../utils/error';
import EditAppPackage from './editAppPackage';
export default {
  name: 'AppVersionList',
  props: {
    appDetail: {
      type: Object
    },
    marketID: {
      type: String
    }
  },
  components: { EditAppPackage },
  data() {
    const defaultPackageVlue = {
      items: [{ name: '', showName: '', value: '' }],
      description: '',
      billtype: '',
      billCycle: '',
      version: '',
      enable: true,
      price: 0,
      isTrial: false,
      enableReview: false
    };
    return {
      appID: this.$route.params.appID,
      timetrans: timetrans,
      showEditPackage: false,
      packages: [],
      versions: [],
      editPackage: defaultPackageVlue,
      defaultPackageVlue,
      column: [
        {
          prop: 'name',
          label: '名称',
          align: 'left',
          scopeStatus: true
        },
        {
          prop: 'packageType',
          label: '套餐类型',
          scopeStatus: true
        },
        {
          prop: 'version',
          label: '所属版本',
          scopeStatus: true
        },
        {
          prop: 'enable',
          label: '状态',
          scopeStatus: true
        },
        {
          prop: 'billtype',
          label: '计费类型',
          scopeStatus: true
        },
        {
          prop: 'billCycle',
          label: '计费周期',
          scopeStatus: true
        },
        {
          prop: 'price',
          label: '单价',
          scopeStatus: true
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: '170px',
          scopeStatus: true
        },
        {
          prop: 'operation',
          label: '操作',
          width: '80px',
          scopeStatus: true
        }
      ]
    };
  },
  created() {
    this.fetchAppPackageList();
    this.fetchAppVersionList();
  },
  methods: {
    showBillCycle(data) {
      switch (data) {
        case 'year':
          return '年度';
        case 'month':
          return '月度';
        case 'week':
          return '周';
        case 'quarter':
          return '季度';
        default:
          return '';
      }
    },
    fetchAppVersionList() {
      fetchAppVersions({ marketID: this.marketID, appID: this.appID })
        .then((res) => {
          this.Loading = false;
          this.versions = res.versions;
        })
        .catch((err) => {
          this.Loading = false;
          if (err.code == 404) {
            this.$router.push({
              name: 'appManage'
            });
          }
        });
    },
    fetchAppPackageList() {
      fetchAppPackages({ marketID: this.marketID, appID: this.appID })
        .then((res) => {
          this.Loading = false;
          this.packages = res.packages;
        })
        .catch((err) => {
          this.Loading = false;
          if (err.code == 404) {
            this.$router.push({
              name: 'appManage'
            });
          }
        });
    },
    deletePackage(row) {
      this.$confirm('是否要删除该套餐?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onDeleteAppPackage(row);
      });
    },
    onDeleteAppPackage(row) {
      deleteAppPackage({
        marketID: this.marketID,
        appID: this.appID,
        packageID: row.packageID
      })
        .then((res) => {
          this.Loading = false;
          this.$message.success('删除成功');
          this.fetchAppPackageList();
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    handleEditPackage(row = {}) {
      if (row.items && row.items.length === 0) {
        row.items = this.defaultPackageVlue.items;
      }
      this.editPackage = JSON.parse(JSON.stringify(row));
      this.showEditPackage = true;
    },
    editPackageSuccess() {
      this.showEditPackage = false;
      this.editPackage = null;
      this.fetchAppPackageList();
    },
    showPackageName(row) {
      if (row.isTrial) {
        return `${row.name}(试用套餐)`;
      }
      return row.name;
    }
  }
};
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/views/generalUser/publishApp/components/appPackage.vue